import { useModal } from "../../../../utils/modal_launcher";
import { LogDiaperChangeModal } from "../log_diaper_change_modal";
import { formatTime, timeAgo } from "./dashboard_utils";

type Props = {
  lastDiaperChange: any;
  refetch: () => void;
};

export const DiaperChangeWidget = ({ lastDiaperChange, refetch }: Props) => {
  const logDiaperChangeModal = useModal(LogDiaperChangeModal);

  return (
    <div className="col-12 col-md-6">
      <div className="card border-0 shadow bg-gray-3 my-4 dashboard-card">
        <div className="card-body text-center">
          <div className="fs-24 fw-bold text-muted text-uppercase">
            Diaper Change
          </div>
          {lastDiaperChange.ended_at ? (
            <>
              <div className="fs-48 desktop-fs-60 fw-bold mt-2">
                {timeAgo(lastDiaperChange.ended_at)}
              </div>
              <div className="d-flex align-items-center justify-content-center gap-2 fs-m-30 fs-40 gray-c fw-bold mt-3">
                <div>at {formatTime(lastDiaperChange.ended_at)}</div>
                <div className="w-0px">
                  <button
                    className="btn btn-text ml-4 position-relative"
                    style={{ fontSize: "1.2rem", lineHeight: 1 }}
                    onClick={() =>
                      logDiaperChangeModal.show({
                        diaperChange: lastDiaperChange,
                        refetch,
                      })
                    }
                    aria-label="Edit diaper change"
                  >
                    <i className="bi bi-pencil" />
                  </button>
                </div>
              </div>
            </>
          ) : (
            <p className="text-muted">No entries logged yet</p>
          )}
          <div className="container mt-4">
            <button
              className="btn btn-primary fs-28 col-12 col-sm-4"
              onClick={() => logDiaperChangeModal.show({ refetch })}
            >
              Log
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
